/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { Popover, Tabs } from 'antd';
import { connect } from "react-redux";
import { actions } from '../../../../../../../store/reducers/dashboard';
import { actions as authActions } from '../../../../../../../store/reducers/authentication';
import Frame from '../frame-with-subject';
import { MapTypeButtons } from './style';
import { mapTypesButtons } from './helper';
import SubjectsMap from '../../../../../../../components/SubjectsMap';
import ComponentWithFocus from '../../../../../../Analysis/components/component-with-focus';
import { InfoCircleOutlined } from '@ant-design/icons';
import DashboardPopover from '../../../../../../../components/dashboards/components/Popover';

const MapWidget = ({
  t = (s) => s,
  data: allData = null,
  PmeDashboardGetWithFilters,
  PmeProjectGetWithFilters,
  CaddDashboardGetWithFilters,
  user = null,
  language,
  selectedProject,
  sourceId,
  module = 'pme',
  isProject = false,
  openSettings = () => { },
  projectData = {},
  filterKey,
  canFetch = false,
}) => {
  const [frameActions, setFrameActions] = useState(null);
  const [activeMapType, setActiveMapType] = useState(mapTypesButtons[0].type);
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    if (filterKey === '10a') {
      setActiveMapType(mapTypesButtons[0].type);
    }
    if (filterKey === '11a') {
      setActiveMapType(mapTypesButtons[1].type);
    }
    if (filterKey === '12a') {
      setActiveMapType(mapTypesButtons[2].type);
    }
    if (filterKey === '13a') {
      setActiveMapType(mapTypesButtons[3].type);
    }
  }, [filterKey]);

  const userSettings = useMemo(() => {
    return (user?.settings?.projects || []).find((s) => s.id === projectData?.id)
  }, [user, projectData]);

  const polygon = useMemo(() => {
    if (userSettings?.visualisation?.typeOfArea === 'customArea' && Array.isArray(userSettings?.visualisation?.area)) {
      return userSettings.visualisation.area;
    }
    return null;
  }, [userSettings]);

  const onMapTypeChange = useCallback((data) => {
    if (module === 'cadd') {
      CaddDashboardGetWithFilters(data);
    } else {
      if (!isProject) {
        PmeDashboardGetWithFilters(data);
      } else {
        PmeProjectGetWithFilters(data);
      }
    }
  }, [module, isProject]);

  const actions = useMemo(() => ({
    closed,
    setClosed,
    unFocus: () => { },
  }), [closed]);

  const mapTypes = useMemo(() => (
    <MapTypeButtons>
      <Tabs
        activeKey={activeMapType}
        defaultActiveKey={activeMapType}
        onChange={(val) => setActiveMapType(val)}
        items={mapTypesButtons.map((btn) => ({
          key: btn.type,
          tabKey: btn.type,
          label: t(btn.label),
        }))}
      />
    </MapTypeButtons>
  ), [activeMapType, t]);

  return (
    <Frame
      title={(
        <div className='flex-row'>
          {t('datastakeMap')}
          <div className='flex-c jus-c ml-2'>
            <Popover
              content={(
                <DashboardPopover
                  title={t('Project Map')}
                  body={t('Information displayed here is based on your selected focus area and subjects.')}
                  action={(
                    <a onClick={openSettings}>
                      {t('Data Settings')}
                    </a>
                  )}
                />
              )}
            >
              <InfoCircleOutlined
                className="hover-icon"
                style={{
                  fontSize: 15,
                }}
              />
            </Popover>
          </div>
        </div>
      )}
      onInit={actions => setFrameActions(actions)}
      optionalHeaderContent={mapTypes}
      filtersTitle={t('Dashboard::Scope of Monitoring')}
      className="project-frame map-header"
    >
      <ComponentWithFocus actions={actions}>
        {canFetch ? (
          <SubjectsMap
            t={t}
            data={allData}
            user={user}
            language={language}
            selectedProject={selectedProject}
            className="project-map"
            sourceId={sourceId}
            module={module}
            polygon={polygon}
            onFiltersChange={onMapTypeChange}
            initialType={mapTypesButtons[0].type}
            frameActions={frameActions}
            activeMapType={activeMapType}
            setActiveMapType={setActiveMapType}
          />
        ) : <div style={{ height: 624 }} />}
      </ComponentWithFocus>
    </Frame>
  );
}

export default connect(null, { ...actions, ...authActions })(MapWidget);
